import {quotes, sample} from 'utils'
import {useState, useEffect} from 'hooks'

// Our hook
export default function useQuote(name: string)
{
  if (!quotes[name]) {
		throw new Error(`There is no quote source named ${name}`)
  }

  const [quote, setQuote] = useState<any>({
  	text: null,
  	source: null
  })

  useEffect(() => {
  	setQuote(sample(quotes[name]))
  }, [name])

  return quote
}
